import { render, staticRenderFns } from "./userCardItem.vue?vue&type=template&id=fe33c7fc&scoped=true&"
import script from "./userCardItem.vue?vue&type=script&lang=js&"
export * from "./userCardItem.vue?vue&type=script&lang=js&"
import style0 from "./userCardItem.vue?vue&type=style&index=0&id=fe33c7fc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe33c7fc",
  null
  
)

export default component.exports